var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9707 14.3619C39.8239 10.9121 39.218 8.10251 39.218 8.10251C39.218 8.10251 36.4025 10.272 34.6562 10.7699C31.7338 8.42259 28.0273 7 24 7C20.044 7 16.4088 8.35146 13.522 10.6276C11.7757 10.3075 8.67506 7.88912 8.67506 7.88912C8.67506 7.88912 8.03354 10.7699 10.0294 14.3264C8.10482 17.0649 7 20.408 7 24C7 33.3891 14.6268 41 24 41C33.3732 41 41 33.3891 41 24C41 20.4435 39.8595 17.1004 37.9707 14.3619Z",
    fill: "#AEDEDE",
    stroke: "#231F20",
    strokeWidth: 1.31886
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 25.5652C14.0566 25.5652 11.4193 22.9334 11.4193 19.697C11.4193 16.4606 14.0566 13.8288 17.2998 13.8288C20.543 13.8288 23.1803 16.4606 23.1803 19.697C23.1803 22.9334 20.543 25.5652 17.2998 25.5652Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 14.2906C20.2935 14.2906 22.7169 16.709 22.7169 19.6965C22.7169 22.6839 20.2935 25.1023 17.2998 25.1023C14.306 25.1023 11.8826 22.6839 11.8826 19.6965C11.8826 16.709 14.306 14.2906 17.2998 14.2906ZM17.2998 13.4015C13.8071 13.4015 10.9916 16.2111 10.9916 19.6965C10.9916 23.1818 13.8071 25.9914 17.2998 25.9914C20.7924 26.027 23.6436 23.1818 23.6436 19.6965C23.6436 16.2111 20.7924 13.4015 17.2998 13.4015Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8365 18.772L17.3355 14.2908L17.7632 18.8076L16.8365 18.772Z",
    fill: "#CE2229"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 20.8704C17.9493 20.8704 18.4759 20.3449 18.4759 19.6967C18.4759 19.0485 17.9493 18.5231 17.2998 18.5231C16.6502 18.5231 16.1237 19.0485 16.1237 19.6967C16.1237 20.3449 16.6502 20.8704 17.2998 20.8704Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6857 20.9413L22.5389 22.0794",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8994 19.697H23.0734",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6143 18.2031L22.6457 17.4207",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9728 16.8159L21.3627 15.4288",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8679 16.0335L19.652 14.2552",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0565 20.9774L12.2032 22.1154",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7359 19.7326H11.5619",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9853 18.2386L11.9895 17.4207",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7695 16.8514L13.4152 15.4644",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8742 16.0691L15.0901 14.2908",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7002 25.5652C27.457 25.5652 24.8197 22.9334 24.8197 19.697C24.8197 16.4606 27.457 13.8288 30.7002 13.8288C33.9434 13.8288 36.5807 16.4606 36.5807 19.697C36.5807 22.9334 33.9434 25.5652 30.7002 25.5652Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7003 14.2906C33.694 14.2906 36.1175 16.709 36.1175 19.6965C36.1175 22.6839 33.694 25.1023 30.7003 25.1023C27.7066 25.1023 25.2831 22.6839 25.2831 19.6965C25.2831 16.709 27.7066 14.2906 30.7003 14.2906ZM30.7003 13.4015C27.2076 13.4015 24.3921 16.2111 24.3921 19.6965C24.3921 23.1818 27.2076 26.027 30.7003 26.027C34.1929 26.027 37.0084 23.2174 37.0084 19.732C37.0084 16.2467 34.1929 13.4015 30.7003 13.4015Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2369 18.772L30.7359 14.2908L31.1636 18.8076L30.2369 18.772Z",
    fill: "#CE2229"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7003 20.8704C31.3498 20.8704 31.8764 20.3449 31.8764 19.6967C31.8764 19.0485 31.3498 18.5231 30.7003 18.5231C30.0507 18.5231 29.5242 19.0485 29.5242 19.6967C29.5242 20.3449 30.0507 20.8704 30.7003 20.8704Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0859 20.9413L35.9392 22.0794",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2998 19.697H36.4738",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0146 18.2031L36.0461 17.4207",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3733 16.8159L34.7632 15.4288",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2683 16.0335L33.0524 14.2552",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4571 20.9774L25.6039 22.1154",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1363 19.7326H24.9623",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3858 18.2386L25.39 17.4207",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1698 16.8514L26.8156 15.4644",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2747 16.0691L28.4906 14.2908",
    stroke: "#231F20",
    strokeWidth: 0.527543,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5996 28.6943H37.4717",
    stroke: "#231F20",
    strokeWidth: 1.31886,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1572 28.7303H13.0587V31.6466H17.1572V28.7303Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6939 29.1569V31.1841H13.4863V29.1569H16.6939ZM17.5849 28.2678H12.5953V32.0732H17.5849V28.2678Z",
    fill: "#231F20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.216 28.7303H19.1174V34.7763H23.216V28.7303Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7526 29.1569V34.3138H19.545V29.1569H22.7526ZM23.6436 28.2678H18.6541V35.2029H23.6436V28.2678Z",
    fill: "#231F20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0252 28.7303H24.9266V35.4876H29.0252V28.7303Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5619 29.1569V35.0251H25.3544V29.1569H28.5619ZM29.4529 28.2678H24.4634V35.9142H29.4529V28.2678Z",
    fill: "#231F20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0482 28.7303H30.9497V30.6508H35.0482V28.7303Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5849 29.1569V30.1883H31.3773V29.1569H34.5849ZM35.4758 28.2678H30.4863V31.0774H35.4758V28.2678Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsD);
export default __webpack_public_path__ + "static/media/StatsD.50afc08a.svg";
export { ForwardRef as ReactComponent };